import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';

import { getPdf } from 'services/quiz.service';
import {
  downloadMessage,
  unAutorizedError,
  errorMessage,
} from 'constants/pop-up-messages';
import { PROMISES_AREA } from 'constants/promises-area';

interface ICanvasPdfParams {
  quizId: string;
  userId?: string;
  email?: string;
}

export const useGetCanvasPdf = () => {
  const [filePdf, setFilePdf] = useState<IPdf | null>(null);

  const { push } = useHistory();

  const getPdfFile = async (params: ICanvasPdfParams) => {
    const { quizId, userId, email } = params;

    if (!userId && !email) {
      return null;
    }

    if (!filePdf) {
      try {
        const { data } = await trackPromise(
          getPdf({
            userId,
            quizId,
            email,
          }),
          PROMISES_AREA.printCareerCanvasPdf
        );

        return data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          if (error.response?.status === 401) {
            unAutorizedError()
              .fire()
              .finally(() => push('/sign-in'));
          } else {
            errorMessage(error?.response?.data.message).fire();
          }

          return null;
        }
      }
    }

    return filePdf;
  };

  const generatePdf = async (params: ICanvasPdfParams) => {
    const { userId, email } = params;

    if (!userId && !email) {
      return;
    }

    const data = await getPdfFile(params);

    if (!data) {
      return;
    }

    setFilePdf(data);

    const html = `
      <p>Click the button below to begin your download.</p>
    `;

    downloadMessage(
      `data:application/octet-stream;base64,${data.file}`,
      data.name,
      html,
      userId || email
    ).fire();
  };

  return { generatePdf };
};
